import {
  THROUGHLINE_HEALTHY_RULES,
  THROUGHLINE_RISK_RULES,
  THROUGHLINE_STATE_DEFINITIONS,
  type ThroughlineNodeState,
} from "@/lib/throughlineAdapter";

export const THROUGHLINE_WINDOW_OPTIONS = [15, 30, 60, 90] as const;
export type ThroughlineWindowDays = (typeof THROUGHLINE_WINDOW_OPTIONS)[number];

export const THROUGHLINE_WINDOW_DEFAULT_COPY = "Default: last 15 days for early signal detection.";

export const THROUGHLINE_STATE_BADGE_STYLES: Record<ThroughlineNodeState, string> = {
  healthy: "bg-emerald-500/15 text-emerald-300 hover:bg-emerald-500/20 border-emerald-400/40",
  stalled: "bg-amber-500/15 text-amber-300 hover:bg-amber-500/20 border-amber-400/40",
  risk: "bg-rose-500/15 text-rose-300 hover:bg-rose-500/20 border-rose-400/40",
};

export function describeThroughlineStateThreshold(state: ThroughlineNodeState) {
  if (state === "healthy") {
    return `On track when evidence >= ${Math.round(THROUGHLINE_HEALTHY_RULES.evidenceGte * 100)}%, agreement >= ${Math.round(THROUGHLINE_HEALTHY_RULES.agreementGte * 100)}%, and momentum >= ${Math.round(THROUGHLINE_HEALTHY_RULES.momentumGte * 100)}%.`;
  }

  if (state === "risk") {
    return `Needs attention when evidence < ${Math.round(THROUGHLINE_RISK_RULES.evidenceLt * 100)}%, agreement < ${Math.round(THROUGHLINE_RISK_RULES.agreementLt * 100)}%, or momentum < ${Math.round(THROUGHLINE_RISK_RULES.momentumLt * 100)}%.`;
  }

  return "Needs consistency is everything between On Track and Needs Attention thresholds.";
}

export function describeThroughlineStateTooltip(state: ThroughlineNodeState) {
  return `${THROUGHLINE_STATE_DEFINITIONS[state].description} ${describeThroughlineStateThreshold(state)}`;
}
